import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  Typography,
  Stepper,
  Step,
  StepLabel,
  IconButton,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import EditImage from '../../events/components/assets/EditImage';
import UpdatedImage from '../../events/components/assets/UpdatedImage';

const EditingProgressCard = (props) => {
   // const {statusOrder} = props
   // const imageSrc = statusOrder > 2 ? EditImage : UpdatedImage
    // const displayText = statusOrder > 2 ? "The Lucivideo is currently being edited!"
    //                       : "Editing is yet to start for this Lucivideo."
    const projectReducer = useSelector((state) => state.projectReducer);
    console.log("status", projectReducer.status_type_order)
    const navigate = useNavigate()
    
  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
        // border: '1px solid #ccc',
        paddingX: 2,
        paddingTop:2,
        // backgroundColor:'#ffffff88',
        // boxShadow:'0px 5px 15px #00000029', 
        borderRadius:'10px',
        mt:1,
        flexDirection:'column'
      }}
    >
     {/* <Box sx={{display:'flex', flexDirection:'column', width:'100%', height:'100%'}}> */}
        {/* <Box sx={{height:'20%', width:'100%',  display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between', px:3}}>
         
                         <Typography sx={{fontSize:{xs:'13px',sm:'14px',md:'14px',lg:'16px',xl:'20px'}, fontWeight:600, letterSpacing:0, fontFamily:'Rubik'}}>{`${projectReducer?.project_details?.name}`}</Typography>
                         <Button 
                           variant="text"
                             color='secondary'
                           onClick={()=> navigate('/brandbox')}
                           sx={{fontSize:{xs:'8px',sm:'9px',md:'10px',lg:'11px',xl:'16px'}, fontWeight:600, height:{xs:'18px',sm:'20px',md:'22px',lg:'24px',xl:"32px"},  fontFamily:'Rubik', textTransform:'none', letterSpacing:'0.65px', textDecoration:'underline'}}
                         >
                           View Brand Guidelines
                         </Button> 
                       
        </Box> */}
     {/* </Box> */}
     <Box sx={{display:'flex', flexDirection:'row', width:'100%', height:'100%'}}>
        <Box sx={{width:'70%', height:'100%',px:5}}>
            <Typography sx={{color:'#888', }} textAlign='center' variant="h3" mt={{xs:12,xl:20}}>{projectReducer.project_details?.status_type_order > 2 ? "The Lucivideo is currently being edited!"
                          : "Editing is yet to start for this Lucivideo."}</Typography>
        </Box>
        <Box sx={{width:'30%', height:'100%'}}>
         {projectReducer.project_details?.status_type_order > 2 ? <EditImage sx={{width:'100%', height:'100%'}}/> :
         <UpdatedImage sx={{width:'100%', height:'100%'}} /> }
         {/* <img src={projectReducer.status_type_order > 2 ? EditImage : UpdatedImage}/> */}
        </Box>
     </Box>

    
    </Box>
  );
};

export default EditingProgressCard;
